<script setup>
  import {computed, useSlots} from "vue";

  defineOptions({
    name: "ComponentButton",
  });

  const slots = useSlots();

  const props = defineProps({
    label: {
      type: String,
      required: "",
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    iconButton: {
      type: Boolean,
      default: false,
    },
    isUpperCase: {
      type: Boolean,
      default: true,
    },
    minWidth: {
      type: Boolean,
      default: true,
    },
    wrap: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(["click"]);

  const hasSlot = computed(() => !!slots.default);
  const hasLabel = computed(() => props.label && props.label.length > 0);

  function click() {
    emit("click");
  }
</script>

<template>
  <button
    v-if="iconButton"
    class="p4umc-btn"
    :class="{'min-w-24': minWidth, 'whitespace-nowrap': !wrap}"
    :disabled="disabled"
    :data-test="getTestId('button')"
    @click="click"
  >
    <div class="flex items-center">
      <div :class="{'mr-2': hasLabel}">
        <slot />
      </div>

      <span v-if="hasLabel" class="font-medium" :class="{uppercase: isUpperCase}">
        {{ label }}
      </span>
    </div>
  </button>

  <button
    v-else
    class="p4umc-btn"
    :class="{'min-w-24': minWidth, 'whitespace-nowrap': !wrap}"
    :disabled="disabled"
    :data-test="getTestId('button')"
    @click="click"
  >
    <div :class="{'flex items-center justify-center': hasSlot && hasLabel, uppercase: isUpperCase}">
      <span v-if="hasLabel" class="font-medium">{{ label }}</span>
      <slot />
    </div>
  </button>
</template>
